<script setup lang="ts">
import { useRedirect } from '../../../composables/use-redirect'
import Login from '../../shared/Login.vue'

const { redirectToSubscriptionPageOrReferrer } = useRedirect()

const onSuccess = () => {
  redirectToSubscriptionPageOrReferrer('login-success')
}
</script>

<template>
  <div class="bx-content bx-login">
    <Login :on-success="onSuccess" />
  </div>
</template>
